import {
  request
 } from './Base';

/******************************************************************************
 * NEW FUNCTION                                                               *
 ******************************************************************************/

/**
 * Create a new alphalink client
 */
export function createAlphalinkAccount(partnerId) {
 return request('/api/alphalink/clients/'+partnerId, "POST");
}

/**
 * Create a new alphalink place
 */
export function createAlphalinkPlace(placeId) {
 return request('/api/alphalink/places/'+placeId, "POST");
}

/******************************************************************************
 * FETCH FUNCTION                                                             *
 ******************************************************************************/

 /**
  * Fetch all alphalink offers to serve in a dropdown form choice
  */
 export function getAlphalinkClients() {
   return request('/api/alphalink/clients');
 }

 /**
  * Fetch all alphalink offers to serve in a dropdown form choice
  */
 export function getAlphalinkPlaces(clientId) {
   return request('/api/alphalink/places/'+clientId);
 }

/**
 * Fetch all alphalink offers to serve in a dropdown form choice
 */
export function getAlphalinkOffers() {
  return request('/api/alphalink/offers');
}

/**
* Fetch all alphalink offers to serve in a dropdown form choice
*/
export function getAlphalinkOfferDataOptions() {
 return request('/api/alphalink/offer_data_options');
}

/**
 * Fetch all alphalink option offers to serve in a dropdown form choice
 */
export function getAlphalinkOptionOffers(offerReference) {
  return request('/api/alphalink/option_offers/'+offerReference);
}



/******************************************************************************
 * SPECIFIC FUNCTION                                                          *
 ******************************************************************************/

 /**
  * Fetch all alphalink option offers to serve in a dropdown form choice
  */
 export function updateCart(cartId) {
   return request('/api/alphalink/mvno/update_cart/'+cartId);
 }
